module.exports = __webpack_public_path__ + "static/media/RecomendaRioDeJaneiro.f4745b08.jpeg";